import React from 'react';

export default function ImaLogo({ size = 40 }) {
  // viewBox: 400 x 300
  const w = size * (400 / 300);
  const h = size;

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 400 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, display: 'block' }}
    >
      {/* ── TV screen outline (hollow) ── */}
      <rect
        x="95" y="18"
        width="272" height="178"
        rx="24"
        stroke="#E8183C"
        strokeWidth="18"
        fill="white"
      />

      {/* ── Stand (hollow) ── */}
      <rect
        x="54" y="148"
        width="76" height="66"
        rx="16"
        stroke="#E8183C"
        strokeWidth="18"
        fill="white"
      />

      {/* ── "INFINITE" inside screen ── */}
      <text
        x="231" y="96"
        textAnchor="middle"
        fontFamily="'DM Sans', Arial, sans-serif"
        fontWeight="800"
        fontSize="46"
        fill="#9B1C1C"
      >
        INFINITE
      </text>

      {/* ── "MINDS" inside screen ── */}
      <text
        x="231" y="152"
        textAnchor="middle"
        fontFamily="'DM Sans', Arial, sans-serif"
        fontWeight="800"
        fontSize="46"
        fill="#9B1C1C"
      >
        MINDS
      </text>

      {/* ── "ACADEMY" below ── */}
      <text
        x="231" y="240"
        textAnchor="middle"
        fontFamily="'DM Sans', Arial, sans-serif"
        fontWeight="400"
        fontSize="24"
        letterSpacing="8"
        fill="#C41E1E"
      >
        ACADEMY
      </text>
    </svg>
  );
}
